import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://api.portal.thecourierguy.co.za/v2/', 
  timeout: 5000,  
  headers: { 
    'Content-Type': 'application/json', 
    'Authorization': `Bearer ${process.env.REACT_APP_SL_API_KEY}`
  }
});

export default axiosInstance;
